import { render, staticRenderFns } from "./doctorhealthfollow.vue?vue&type=template&id=0d228a8d&scoped=true&"
import script from "./doctorhealthfollow.vue?vue&type=script&lang=js&"
export * from "./doctorhealthfollow.vue?vue&type=script&lang=js&"
import style0 from "./doctorhealthfollow.vue?vue&type=style&index=0&id=0d228a8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d228a8d",
  null
  
)

export default component.exports